export default () => {
  return {
    theme: 'dark'/* window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' */,
    delay: 1250,
    animationClass: '',
    getUserColorPreference() {
      /* console.log(this.theme); */
      this.theme = localStorage.getItem('userPrefers') || this.theme,
      document.querySelector('body').classList.add(`${this.theme}`)
      // Da togliere se implementeremo le transizioni di pagina
      setTimeout(() => {
        document.querySelector('html').classList.remove('invisible')
      }, 400)
      this.$dispatch('changetheme', { theme: this.theme, pageLoad: true })
    },
    changeTheme(theme, pageLoad) {
      this.animationClass = 'shadow-enlarge'
      this.theme = this.themeOpposite
      localStorage.setItem('userPrefers', this.theme)
      setTimeout(() => {
        this.animationClass = ''
      }, this.delay)
      this.$dispatch('changetheme', { theme: this.theme, pageLoad: pageLoad })
      setTimeout(() => {
        document.querySelector('body').classList.remove('dark', 'light')
        document.querySelector('body').classList.add(`${this.theme}`)
      }, this.delay * 0.5)
    },
    get themeOpposite(){
      return this.theme === 'dark' ? 'light' : 'dark'
    },
  }
}
